export const courierReportData = {
  shipments: 1280,
  deliveredPercentage: 91.2,
  inTransit: 74,
  rtoPercentage: 4.8,
  totalFreightPaid: 128500,
  freightCollected: 142000,
  shippingGainLoss: 13500,
};

export const courierShipmentData = [
  {
    courier: "Shiprocket",
    shipments: 420,
  },
  {
    courier: "Delhivery",
    shipments: 360,
  },
  {
    courier: "Xpressbees",
    shipments: 280,
  },
  {
    courier: "BlueDart",
    shipments: 140,
  },
  {
    courier: "Ecom Express",
    shipments: 80,
  },
];

export const deliveryTimeData = [
  {
    courier: "Shiprocket",
    days: 3.2,
  },
  {
    courier: "Delhivery",
    days: 3.8,
  },
  {
    courier: "Xpressbees",
    days: 3.5,
  },
  {
    courier: "BlueDart",
    days: 2.9,
  },
  {
    courier: "Ecom Express",
    days: 4.1,
  },
];

export const profitLossData = {
  revenue: 1250000,
  materialMakingCost: 475000,
  courierCost: 115000,
  gatewayFees: 29000,
  discountsCoupons: 65000,
  refunds: 42000,
  netProfit: 524000,
  margin: 41.92,
};

export const revenueProfitData = [
  {
    month: "Apr",
    revenue: 180000,
    profit: 72000,
  },
  {
    month: "May",
    revenue: 195000,
    profit: 81000,
  },
  {
    month: "Jun",
    revenue: 205000,
    profit: 85000,
  },
  {
    month: "Jul",
    revenue: 210000,
    profit: 87000,
  },
  {
    month: "Aug",
    revenue: 220000,
    profit: 92000,
  },
  {
    month: "Sep",
    revenue: 240000,
    profit: 107000,
  },
];

export const profitWaterfallData = [
  {
    name: "Revenue",
    amount: 125000,
  },
  {
    name: "Material",
    amount: -47500,
  },
  {
    name: "Courier",
    amount: -11500,
  },
  {
    name: "Gateway",
    amount: -2900,
  },
  {
    name: "Discounts",
    amount: -6500,
  },
  {
    name: "Refunds",
    amount: -4200,
  },
  {
    name: "Net Profit",
    amount: 52400,
  },
];
